export default {
	init() {
		// JavaScript to be fired on the home page
		veryQueer();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};

function veryQueer()
{
	$('.pink-trigger').on('mouseenter', function () {
		$('body').addClass('pink-active');
	});

	$('.pink-trigger').on('mouseleave', function () {
		$('body').removeClass('pink-active');
	});
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js